import { useState } from 'react';
import { useUnitListByBuildingId } from '../useUnits';

type Option = {
  id: string;
  name: string;
}

export const defaultUnit: Option = {
  id: '',
  name: '',
};

export const useUnitList = () => {
  const [unitList, setUnitList] = useState<Option[]>([]);
  const { getUnitListByBuildingId, isLoading } = useUnitListByBuildingId();

  const updateUnitListByBuildingId = async (buildingId?: string) => {
    try {
      if (buildingId) {
        const result = await getUnitListByBuildingId(String(buildingId));

        if (result?.listOfUnits) {
          const newOptions = result.listOfUnits.map((unit) => ({
            id: unit.unitId || '',
            name: unit.unitName,
          }));

          setUnitList(newOptions);
        }

        if (!result?.listOfUnits) {
          setUnitList([])
        }
      }
    } catch (e) {
      setUnitList([])
    }
  }

  return {
    unitList,
    unitListLoading: isLoading,
    unitListLength: unitList.length,
    updateUnitListByBuildingId
  };
}
